import { useDataFlowStore } from '@/stores/dataflowStore';
import { TaskChainTable } from './TaskChainTable';
import { InstanceDetail } from './InstanceDetail';
import { TemplateRuntimeView } from './TemplateRuntimeView';
import { TimelineRuntimeView } from './TimelineRuntimeView';
import { QueueRuntimeView } from './QueueRuntimeView';

export function RuntimeView() {
  const { runtimeView, setRuntimeView, selectedInstanceId } = useDataFlowStore();

  const tabs = [
    { id: 'task_chain' as const, label: 'By Task Chain' },
    { id: 'template' as const, label: 'By Template' },
    { id: 'timeline' as const, label: 'Timeline' },
    { id: 'queue' as const, label: 'Queue' },
  ];

  return (
    <div className="flex flex-col h-full">
      {/* Sub-tabs */}
      <div className="flex border-b border-[var(--border)] bg-[#0f1115] px-3">
        {tabs.map(tab => (
          <button
            key={tab.id}
            onClick={() => setRuntimeView(tab.id)}
            className={`px-4 py-2 text-xs font-medium ${
              runtimeView === tab.id
                ? 'text-[#7dd3fc] border-b-2 border-[#7dd3fc]'
                : 'text-[#64748b] hover:text-[#94a3b8]'
            }`}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* Content */}
      <div className="flex flex-1 min-h-0 overflow-hidden">
        <div className={`${selectedInstanceId ? 'w-3/5' : 'w-full'} border-r border-[var(--border)] overflow-auto`}>
          {runtimeView === 'task_chain' && <TaskChainTable />}
          {runtimeView === 'template' && <TemplateRuntimeView />}
          {runtimeView === 'timeline' && <TimelineRuntimeView />}
          {runtimeView === 'queue' && <QueueRuntimeView />}
        </div>

        {selectedInstanceId && (
          <div className="w-2/5 bg-[#12161c]">
            <InstanceDetail />
          </div>
        )}
      </div>
    </div>
  );
}
